import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl} from '@angular/forms';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { DivisionDiaglogBoxComponent } from '../division-diaglog-box/division-diaglog-box.component';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-division-data',
  templateUrl: './division-data.component.html',
  styleUrls: ['./division-data.component.scss']
})
export class DivisionDataComponent implements OnInit {
  divisionList: any;
  DivisionSearchForm;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  SessionNo: any;
  setIntervalSearch: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    public router: Router,
    private spinner:NgxSpinnerService, 
    ) 
    {this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    window.scroll(0, 0);
    this.getDivisionData();
    this.DivisionSearchForm = this.fb.group({
      SearchString: new FormControl ('')
    });
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getDivisionData();
    this.keypress();
  }

  getDivisionData() {
      this.spinner.show();
        const payload = {};
        payload['PageSize'] = this.pageSize;
        payload['PageNumber'] = this.currentPage;
        this.umsService.getDivision(payload).subscribe(res => {
          if(res.status){
            this.spinner.hide();
            this.divisionList = res.data;
            this.totalItems = res.data[0].TotalRecords;
           
          }
          else{
            this.totalItems = 0;
            this.spinner.hide();
          }
      
    }, (ERROR: HttpErrorResponse) => {
      this.divisionList = [];
      let  data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
   });
  }

  keypress(){
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.divisionList = [];
      let payload = {}
      payload['SearchString'] = this.DivisionSearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchDivision(payload).subscribe(res => {
        if(res.status){
          this.divisionList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.divisionList = [];
          this.totalItems = 0;
        }
       
        }, (ERROR: HttpErrorResponse) => {
          this.divisionList = [];
        });
    },1000)
   
  }

  addnewrecord() {
    const dialogRef = this.dialog.open(DivisionDiaglogBoxComponent, {
      width: '90vh',
      data: {key : "New"},
      disableClose: true  
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      this.getDivisionData();
      this.DivisionSearchForm.controls['SearchString'].setValue('');
    });
  }
  editData(k){
    const dialogRef = this.dialog.open(DivisionDiaglogBoxComponent, {
      width: '90vh',
      data: { selected: k, key : "Edit"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data 
        this.getDivisionData();
        this.DivisionSearchForm.controls['SearchString'].setValue('');
    });
  }
  deleteData(k){
    const dialogRef = this.dialog.open(DivisionDiaglogBoxComponent, {
      width: '90vh',
      data: { selected: k, key : "Delete"},
      disableClose: true 
    });
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
        this.getDivisionData();
        this.DivisionSearchForm.controls['SearchString'].setValue('');
    });
  }

  Print(){
    let submitpayload = this.DivisionSearchForm.value;
    let payload1 = {}
    payload1['SearchString'] = submitpayload['SearchString'],
    payload1['MenuName'] ='Master-Division';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 114,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
